import { TableColumn } from "components/table/Table";
import TableBoolean from "components/table/renderComponents/TableBoolean";
import TableDescTruncate from "components/table/renderComponents/TableDescTruncate";
import TableImage from "components/table/renderComponents/TableImage";
import TableTruncate from "components/table/renderComponents/TableTruncate";
import TableVideo from "components/table/renderComponents/TableVideo";
import { getDataBasedOnLang } from "utils/getDataBasedOnLang";

export interface Data {
  _id: string;
  image: string;
  listOrderNumber: number;
  createdAt: string;
}

export const columns: TableColumn<Data>[] = [
  {
    key: "_id",
    label: "id",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item._id} withCopy />,
  },
  {
    key: "image",
    label: "image",
    sortable: true,
    render: (item: Data) => <TableImage image={item?.image} />,
  },
  {
    key: "listOrderNumber",
    label: "listOrderNumber",
    sortable: true,
    render: (item: Data) => <p>{item?.listOrderNumber}</p>,
  },

  { key: "createdAt", label: "createdAt", sortable: true },
];
